// createQueryKeys
import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { GetChatEmoticonGroupParams, GetChatEmoticonParams } from '@module/apis/client-side/chat-emoticon/type';

export const chatEmoticonQueryKeys = createQueryKeys('chatEmoticon', {
  getChatEmoticon: (params: GetChatEmoticonParams) => [params],
  getChatEmoticonGroup: (params: GetChatEmoticonGroupParams) => [params],
});
